import * as types from '../actions/actionTypes';

export function clearNotification(notification) {
	return { 
        type: types.CLEAR_NOTIFICATION_REQUESTED,
		notification: notification
	};
}


// WEBPACK FOOTER //
// ./src/js/actions/notificationActionCreators.js